import { EXPRESS_ENVIRONMENT } from '../types';
import { LatLng } from '../api/models/locations';
import { Environment } from '@analytika/analytika-web';
import pkgJSON from '../../package.json';

export const PUBLIC_URL = process.env.VITE_PUBLIC_URL;
export const AUTH_TOKEN_NAME = '__at__';
export const AUTH_TOKEN_EXPIRY_TIME_NAME = '__et__';
export const ATTEMPTS_REJECTED_COUNT_NAME = 'attemptsUnauthorizedCount';
export const ATTEMPTS_REJECTED_COUNT_MAX = 3;

export const AUTH_ENDPOINT = `${process.env.VITE_IDP_AUTHORIZATION_ENDPOINT}?response_type=token&client_id=${
  process.env.VITE_IDP_CLIENT_ID
}&redirect_uri=${encodeURIComponent(process.env.VITE_IDP_TOKEN_CALLBACK_URL as string)}`;

export const AUTH_ENDPOINT_NEW_FLOW = `${process.env.VITE_IDP_AUTHORIZATION_ENDPOINT}?response_type=token&client_id=${
  process.env.VITE_IDP_CLIENT_ID_NEW_FLOW
}&redirect_uri=${encodeURIComponent(process.env.VITE_IDP_TOKEN_CALLBACK_URL as string)}`;

export const TOKEN_CALLBACK_PATH = process.env.VITE_IDP_TOKEN_CALLBACK_PATH;

export const DEFAULT_PICK_UP_LOCATION_ID_KEY = 'defaultPickUpLocationId';
export const DEFAULT_CITY_ID_KEY = 'defaultCityId';
export const DEFAULT_PAYMENT_METHOD_ID_KEY = 'defaultPaymentMethodId';
export const SECONDARY_PAYMENT_METHOD_ID_KEY = 'secondaryPaymentMethodId';
export const IS_WALLET_CREDIT_USED_KEY = 'isWalletCreditUsed';

export const CUSTOM_LOCATION_ID = 'customLocationId';

export const PAYMENTS_SECTION_ID = 'paymentsSection';

export const ENV = import.meta.env.MODE as EXPRESS_ENVIRONMENT;
export const APP_NAME = 'Express-Portal';
export const APP_VERSION = pkgJSON.version;

export const GOOGLE_MAP_API_KEY = process.env.VITE_GOOGLE_MAP_API_KEY;

export const SAGW_API_BASE_URL = process.env.VITE_SAGW_API_BASE_URL;
export const MOT_GW_API_BASE_URL = process.env.VITE_MOT_GW_API_BASE_URL;

export const GOOGLE_ANALYTICS_TRACKING_ID = process.env.VITE_GOOGLE_ANALYTICS_TRACKING_ID;

export const PAST_DELIVERY_CACHE_TIME = 5 * 60 * 1000;

export const FETCH_PAST_DELIVERIES_KEY = 'fetchPastDeliveries';

export const FETCH_DELIVERY_TRACKING_KEY = 'fetchDeliveryTracking';

export const FETCH_DELIVERY_DETAILS_KEY = 'fetchDeliveryDetails';

export const DELIVERY_REPORT_ID_KEY = 'deliveryReportId';

export const DASHBOARD_DATA_RANGE_DAYS = 30;

export const MAX_FETCH_LOCATIONS_SIZE = 100;

export const MIN_WALLET_BALANCE = 20;

export const CPAY_CHECKOUT_REDIRECT_URL = process.env.VITE_CPAY_CHECKOUT_REDIRECT_URL;

export const INVOICES_PAGE_PATH = '/invoices/:id';

export const CPAY_CALLBACK_PATH = process.env.VITE_CPAY_CALLBACK_PATH;

export const CPAY_SUCCESS_STATUS = 'success';

export const DUBAI_LAT_LNG: LatLng = {
  lat: 25.2048,
  lng: 55.2708
};

export const EVENT_COLLECTOR_URL = process.env.VITE_EVENT_COLLECTOR_URL;
export const ANALYTIKA_API_KEY = process.env.VITE_ANALYTIKA_API_KEY;
export const ANALYTIKA_EVENT_SOURCE = process.env.VITE_ANALYTIKA_EVENT_SOURCE;
export const ANALYTIKA_V2_ENV = process.env.VITE_ANALYTIKA_V2_ENV as Environment;

export const BIFROST_TRANSPORTER_URL = process.env.VITE_BIFROST_TRANSPORTER_URL;
export const BIFROST_LOCATIONS_URL = process.env.VITE_BIFROST_LOCATIONS_URL;
export const BIFROST_MERCHANT_SERVICE_URL = process.env.VITE_BIFROST_MERCHANT_SERVICE_URL;

export const PURCHASE_CALLBACK_URL = process.env.VITE_PURCHASE_CALLBACK_URL;

export const WALLET_PAYMENT_METHOD_ID = 0;
export const MERCHANT_CONFIG_FETCHING_INTERVAL_MIN = 15;

export const TIMESLOT_MAX_DAYS = 3;

export const PICKUP_CITIES_PAGE_SIZE = 50;
export const CITIES_CACHE_KEY = 'express_portal_cities_cache';
export const CITIES_CACHE_TTL = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds
export const CITIES_CACHE_VERSION = 1; // Increment this to invalidate old caches
